/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { computed } from '@ember/object';
import SubjectStepModel from 'cio/models/subject-step';
import characterFromNumber from 'cio/utils/character-from-number';
import { formatRandomCohortPathValue } from 'cio/utils/visual-workflow-builder/branching';

interface RandomCohortSignature {
  Element: HTMLDivElement;
  Args: {
    step: SubjectStepModel;
  };
}

export default class RandomCohort extends Component<RandomCohortSignature> {
  @computed('args.step.{branchIndex,action}')
  get branchTaken() {
    let {
      branchIndex,
      action: { cohorts, isDistributedEvenly },
      action,
    } = this.args.step;

    return `Path ${characterFromNumber(branchIndex + 1)}: ${
      isDistributedEvenly && cohorts[branchIndex] === 1
        ? formatRandomCohortPathValue(action.evenDistributionValue, true)
        : formatRandomCohortPathValue(cohorts[branchIndex], true)
    }%`;
  }
}
